/**
 * Formata um valor numérico para moeda BRL.
 */
export function formatCurrency(value) {
    if (!value) return '';
    const num = parseFloat(value);
    if (isNaN(num)) return '';
    return num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

/**
 * Ordena chaves de andar em ordem decrescente (numérica quando possível).
 */
export function sortFloorKeys(keys) {
    return [...keys].sort((a, b) => {
        const numA = parseInt(a, 10);
        const numB = parseInt(b, 10);
        if (!isNaN(numA) && !isNaN(numB)) return numB - numA;
        return b.localeCompare(a);
    });
}

/**
 * Ordena chaves de bloco em ordem crescente (numérica quando possível).
 */
export function sortBlockKeys(keys) {
    return [...keys].sort((a, b) => {
        const numA = parseInt(a, 10);
        const numB = parseInt(b, 10);
        if (!isNaN(numA) && !isNaN(numB)) return numA - numB;
        return a.localeCompare(b);
    });
}

/**
 * Ordena unidades pelo número de forma crescente.
 */
export function sortUnits(units) {
    return [...units].sort((a, b) => {
        const numA = parseInt(a.number, 10);
        const numB = parseInt(b.number, 10);
        if (!isNaN(numA) && !isNaN(numB)) return numA - numB;
        return (a.number || '').localeCompare(b.number || '');
    });
}

/**
 * Agrupa unidades na estrutura: { [block]: { [floor]: unit[] } }
 */
export function groupUnits(units) {
    const grouped = {};
    units.forEach(unit => {
        const block = unit.block != null && unit.block !== '' ? unit.block : '—';
        const floor = unit.floor != null && unit.floor !== '' ? unit.floor : 'S/A';
        if (!grouped[block]) grouped[block] = {};
        if (!grouped[block][floor]) grouped[block][floor] = [];
        grouped[block][floor].push(unit);
    });
    return grouped;
}
